<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  // import { getToken } from './common/localinfo.js';
  // import { login } from "./apis/user";
  import { isWechat } from "./common/util";

  export default{
  	  created(){

      },
      mounted(){

      }
  }
</script>
